import { createRouterMiddleware } from "@lagunovsky/redux-react-router";
import { applyMiddleware, compose, createStore } from "redux";

import history from "./history";
import {
  apiErrorMessage,
  currencyExchanger,
  getBalance,
  getMemberData,
  initializeApi,
  manualUpdateBalance,
  periodicDataUpdater,
  updateEventList,
  userLogout,
} from "./middleware";
import AllReducers from "./reducers/AllReducers";

const routerMiddleware = createRouterMiddleware(history);

const enhancers = [];
const middleware = [
  routerMiddleware,
  apiErrorMessage,
  periodicDataUpdater,
  initializeApi,
  getMemberData,
  getBalance,
  userLogout,
  currencyExchanger,
  updateEventList,
  manualUpdateBalance,
];

if (
  // process.env.REACT_APP_SECRET_ENV === "development" &&
  window.__REDUX_DEVTOOLS_EXTENSION__
) {
  enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(AllReducers, composedEnhancers);

export default store;
